import { mesaColorNames } from '@/src/common/theme'
import { openInAppBrowser } from '@/src/common/utils/openInAppBrowser'
import { ComponentProps } from 'react'
import { SizableText, styled } from 'tamagui'

const FormHelpLinkText = styled(SizableText, {
  size: '$5',
  textDecorationLine: 'underline',
  color: mesaColorNames['Mesa - Brand/Secondary #223843'],
})

export function FormHelpLink({
  children,
  url,
  ...props
}: { children: React.ReactNode; url: string } & ComponentProps<typeof FormHelpLinkText>) {
  return (
    <FormHelpLinkText {...props} onPress={() => void openInAppBrowser(url, ' ')}>
      {children}
    </FormHelpLinkText>
  )
}
